// @flow

export const KASKO_PRODUCT_NAME = 'casco';
export const KASKO_NEW_CALCULATION_PRODUCT_NAME = `${KASKO_PRODUCT_NAME}-new`;
export const KASKO_PROLONGATION_PRODUCT_NAME = `${KASKO_PRODUCT_NAME}-prolong`;
export const KASKO_URBAN_PRODUCT_NAME = `${KASKO_PRODUCT_NAME}-urban`;
export const KASKO_CALLBACK_PRODUCT_NAME = `${KASKO_PRODUCT_NAME}-callback`;

export const OSAGO_PRODUCT_NAME = 'osago';
export const OSAGO_EDIT_PRODUCT_NAME = 'osago-change';
// Категория для логирования ВИ, у которых канал продаж не сайт
export const OSAGO_EDIT_NON_SITE_CHANNEL_PRODUCT_NAME = 'osago-change-not901';

export const TRAVEL_PRODUCT_NAME = 'vzr';
export const TRAVEL_SCHENGEN_PRODUCT_NAME = 'vzr-schengen';
export const TRAVEL_RF_PRODUCT_NAME = 'vzr-rf';
export const FLAT_PRODUCT_NAME = 'property';
export const CLAIM_SERVICE_PRODUCT_NAME = 'claim-status';